import Vue from "vue";
import { postApi } from "@/utils/http";
import { formSource } from "@/utils/mdc";
import { _order, getReversed } from "@/utils/order";

export default {
  namespaced: true,
  state: { sources: [], domainUID: null },
  mutations: {
    edit(state, { s, obj }) {
      const index = state.sources.findIndex((x) => x.uid === s.uid);
      if (index !== -1) {
        const item = state.sources[index];
        Vue.set(state.sources, index, { ...item, ...obj });
      }
    },
    add(state, source) {
      state.sources.unshift(source);
    },
    remove(state, d) {
      const index = state.sources.findIndex((x) => x.uid === d.uid);
      if (index !== -1) Vue.delete(state.sources, index);
    },
    set(state, { sources, domainUID }) {
      state.sources = sources;
      state.domainUID = domainUID;
    },
    clear(state) {
      state.sources = [];
      state.domainUID = null;
    },
  },
  actions: {
    async fetch({ commit, state }, { domainUID, force = false }) {
      if (
        state.sources.length === 0 ||
        force ||
        domainUID !== state.domainUID
      ) {
        const sources = await postApi("get/domainPackageSources", {
          domainUID: domainUID,
        });

        commit("set", {
          sources: sources.map((x) => formSource(x)),
          domainUID,
        });
      }
    },
    async fetchAll({ commit, state, rootState, dispatch }, force) {
      if (state.sources.length === 0 || force) {
        let sources = await postApi("get/packageSources", {});

        if (sources) {
          await dispatch(
            "settings/getUserSetting",
            { path: "sources", key: "order" },
            { root: true }
          );

          sources = sources.map((x) => formSource(x));
          sources = _order(sources, rootState.settings.user.sources?.order);

          commit("set", {
            sources: sources,
            domainUID: null,
          });
        }
      }
    },

    async createInternal({ commit, state }, name) {
      const res = await postApi("create/internalPackageSource", { name });
      if (res && res[0]) commit("add", formSource(res[0]));
    },

    async createExternal({ commit, state }, { name, url }) {
      const res = await postApi("create/packageSource", {
        name: name,
        url: url,
        description: "",
        username: "",
        password: "",
        key: "",
        css: "",
      });

      if (res && res[0]) commit("add", formSource(res[0]));
    },

    async delete({ commit, state }, source) {
      await postApi("delete/packageSource", { uid: source.uid });
      commit("remove", source);
    },
    async order({ dispatch, commit, state, rootState }, order) {
      const stateOrder = rootState.settings.user.sources?.order;
      order = getReversed(stateOrder, order);

      dispatch(
        "settings/setUser",
        { path: "sources", key: "order", value: order },
        { root: true }
      );

      commit("set", {
        sources: _order(state.sources, order),
        domainUID: state.domainUID,
      });
    },
  },
  getters: {
    single: (state) => (repoUID) => {
      return state.sources.find((x) => x.uid === repoUID);
    },
  },
};
